
import Vue from 'vue';
import Component from 'vue-class-component';
import { db } from '@/plugins/firebase';
import { Project } from '@/types';
import { Entry } from '@/types';
import { getModule } from 'vuex-module-decorators';
import Transcription from '@/store/modules/transcription';
import store from '@/store/store';
import { Watch } from 'vue-property-decorator';

const trscModule = getModule(Transcription, store);

@Component
export default class TrscEditor extends Vue {
  editor: any = {};
  intervalId: number = 0;
  tempChanged = false;
  fab = false;

  get text() {
    if (!trscModule.transcription) {
      return '';
    } else if (trscModule.isCurrentUserEditing || trscModule.isSyncMode) {
      return trscModule.transcription.tempText;
    } else {
      return trscModule.transcription.text;
    }
  }

  get currentTranscription() {
    return trscModule.currentTranscription;
  }

  get isCurrentUserEditing() {
    return trscModule.isCurrentUserEditing;
  }

  get transcriptionId() {
    return trscModule.transcription.id;
  }

  get;
  @Watch('text')
  onTempTextChanged() {
    this.editor.value = this.text;
  }

  @Watch('isCurrentUserEditing')
  whenUserEditingChanged() {
    this.toggleDisabled();
    this.setEditorText();
  }

  @Watch('transcriptionId')
  whenTranscriptionIdChanged() {
    this.toggleDisabled();
    clearInterval(this.intervalId);
    this.intervalId = window.setInterval(() => {
      if (this.isCurrentUserEditing && this.tempChanged) {
        const tempText = trscModule.currentTranscription.tempText;
        trscModule.updateTranscription({ tempText });
      }
    }, 3000);
  }

  toggleDisabled() {
    if (this.editor) this.editor.disabled = !trscModule.isCurrentUserEditing;
  }

  @Watch('transcriptionId')
  setEditorText() {
    if (this.editor) {
      this.editor.value = this.text;
    }
  }

  setupEditor() {
    const container = document.getElementById('trsc-editor');
    const Editor = (<any>window).KojiEditor.Editor;
    this.editor = new Editor(container, this.text);
    this.editor.watch('src', () => {
      if (this.isCurrentUserEditing && this.text !== this.editor.value) {
        //console.log('update', this.editor.value);
        const src = this.editor.value;
        trscModule.updateTranscriptionLocally({ tempText: src });
        this.tempChanged = true;
      }
    });
  }

  get selected() {
    const { start, end } = this.editor.selection;
    return this.editor.value.slice(start, end);
  }

  insertOdoriji() {
    const odoriji = ['ゝ', 'ヽ', 'ゞ', 'ヾ', '〳〵', '〴〵'];
    const { start, end } = this.editor.selection;
    const selected = this.editor.value.slice(start, end);
    const index = odoriji.indexOf(selected);
    if (index >= 0 && index < odoriji.length - 1) {
      this.editor.insertOrReplace(odoriji[index + 1]);
    } else {
      this.editor.insertOrReplace(odoriji[0]);
    }
  }

  insertFreq() {
    const chars = ['ゟ', 'ゐ', 'ヰ', 'ゑ', 'ヱ'];
    const { start, end } = this.editor.selection;
    const selected = this.editor.value.slice(start, end);
    const index = chars.indexOf(selected);
    if (index >= 0 && index < chars.length - 1) {
      this.editor.insertOrReplace(chars[index + 1]);
    } else {
      this.editor.insertOrReplace(chars[0]);
    }
  }

  insertIllegibles() {
    const chars = ['■', '□'];
    const { start, end } = this.editor.selection;
    const selected = this.editor.value.slice(start, end);
    const index = chars.indexOf(selected);
    if (index >= 0 && index < chars.length - 1) {
      this.editor.insertOrReplace(chars[index + 1]);
    } else {
      this.editor.insertOrReplace(chars[0]);
    }
  }

  insertKunten() {
    const chars = [
      '￣オクリガナ',
      '＿レ',
      '＿一',
      '＿二',
      '＿三',
      '＿上',
      '＿中',
      '＿下',
    ];
    const { start, end } = this.editor.selection;
    const selected = this.editor.value.slice(start, end);
    const index = chars.indexOf(selected);
    if (index >= 0 && index < chars.length - 1) {
      this.editor.insertOrReplace(chars[index + 1]);
    } else {
      this.editor.insertOrReplace(chars[0]);
    }
  }

  insertFurigana() {
    if (this.selected && this.selected.length > 0) {
      this.editor.markup('／', '（ふりがな）');
    } else {
      this.editor.markup('／漢字', '（ふりがな）');
    }
  }

  insertWarigaki() {
    const { start, end } = this.editor.selection;
    const selected = this.editor.value.slice(start, end);
    if (selected && selected.length > 0) {
      this.editor.markup('《割書：', '｜二行目》');
    } else {
      this.editor.markup('《割書：一行目', '｜二行目》');
    }
  }

  insertAnnotation() {
    const { start, end } = this.editor.selection;
    const selected = this.editor.value.slice(start, end);
    if (selected && selected.length > 0) {
      this.editor.markup('【', '】');
    } else {
      this.editor.markup('【ここに注記を書きます', '】');
    }
  }

  insertPlace() {
    const { start, end } = this.editor.selection;
    const selected = this.editor.value.slice(start, end);
    if (selected && selected.length > 0) {
      this.editor.markup('《場所：', '》');
    } else {
      this.editor.markup('《場所：ここに場所名》', '');
    }
  }

  mounted() {
    this.setupEditor();
    this.toggleDisabled();
  }

  created() {
    clearInterval(this.intervalId);
    this.intervalId = window.setInterval(() => {
      if (this.isCurrentUserEditing) {
        const tempText = trscModule.currentTranscription.tempText;
        trscModule.updateTranscription({ tempText });
      }
    }, 3000);
  }

  beforeDestroy() {
    clearInterval(this.intervalId);
  }
}
